import { render, staticRenderFns } from "./tryher-grid-percent.vue?vue&type=template&id=1184a924&scoped=true&"
import script from "./tryher-grid-percent.vue?vue&type=script&lang=js&"
export * from "./tryher-grid-percent.vue?vue&type=script&lang=js&"
import style0 from "./tryher-grid-percent.vue?vue&type=style&index=0&id=1184a924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184a924",
  null
  
)

export default component.exports